/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//French (France)
export default {
  'ai-floating-context-menu.ai-dynamic-surface.rovo-panel-title': 'Rovo',
  'ai-smart-button.ai-actions.actions.section.text': 'Actions',
  'ai-smart-button.ai-actions.give-feedback-action.title': 'Envoyer un feedback',
  'ai-smart-button.ai-actions.help.section.text': 'Aide',
  'ai-smart-button.ai-actions.input.link-picker-button-label': 'Lier',
  'ai-smart-button.ai-actions.input.mention-button-label': 'Mentionner',
  'ai-smart-button.ai-actions.input.send-button-label': 'Envoyer',
  'ai-smart-button.ai-actions.item.betaLozenge': 'BÊTA',
  'ai-smart-button.ai-actions.item.newLozenge': 'NOUVEAU',
  'ai-smart-button.ai-actions.rovo-agents.add-icon-label': 'Ajouter une icône',
  'ai-smart-button.ai-actions.rovo-agents.automation-icon-label': "Icône d'automatisation",
  'ai-smart-button.ai-actions.rovo-agents.automations.text': 'Automatisations',
  'ai-smart-button.ai-actions.rovo-agents.create-agent.text': 'Parcourir les agents',
  'ai-smart-button.ai-actions.rovo-agents.create-automation.text': 'Créer une automatisation',
  'ai-smart-button.ai-actions.rovo-agents.section.text': 'Studio',
  'ai-smart-button.ai-dynamic-surface.components.greeting.intro-text-headline': 'Bonjour {name},',
  'ai-smart-button.ai-proactive-nudge.dismiss': 'Ignorer',
  'ai-smart-button.feedback-action.ask-question-option': 'Poser une question',
  'ai-smart-button.feedback-action.cancel-button-label': 'Annuler',
  'ai-smart-button.feedback-action.choose-feedback-option': 'Choisissez un élément',
  'ai-smart-button.feedback-action.feedback-entry-bug-heading': 'Décrivez le bug ou le problème',
  'ai-smart-button.feedback-action.feedback-entry-comment-heading': 'Dites-nous tout',
  'ai-smart-button.feedback-action.feedback-entry-question-heading': 'Que souhaitez-vous savoir ?',
  'ai-smart-button.feedback-action.feedback-entry-suggest-heading': 'Dites-nous ce que vous aimeriez améliorer',
  'ai-smart-button.feedback-action.feedback-modal-heading': 'Donner votre avis',
  'ai-smart-button.feedback-action.leave-comment-option': 'Laisser un commentaire',
  'ai-smart-button.feedback-action.report-bug-option': 'Signaler un bug',
  'ai-smart-button.feedback-action.research-participation-message': "J'aimerais participer à la recherche produit",
  'ai-smart-button.feedback-action.select-feedback-heading': 'Sélectionner le sujet de votre feedback',
  'ai-smart-button.feedback-action.submit-button-label': 'Envoyer des commentaires',
  'ai-smart-button.feedback-action.suggest-improvement-option': 'Suggérer une amélioration',
  'ai-smart-button.feedback-action.title': 'Envoyer un feedback',
  'ai-smart-button.feedback-item.icon-label': 'Icône de feedback',
  'ai-smart-button.reference.close-button-label': 'Fermer',
};
